"use client";

import { Tooltip } from "@base-ui/react/tooltip";
import { ClipboardCheck } from "lucide-react";
import { useState } from "react";
import ShareIcon from "@/components/icons/share";
import { Button } from "@/components/ui/button";

const COPY_RESET_DELAY = 1000;

const ShareButton = ({ url }: { url?: string }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleOpenChange = (
    nextOpen: boolean,
    eventDetails: Tooltip.Root.ChangeEventDetails,
  ) => {
    // Tıklama sırasında tooltip'i açık tut, "Kopyalandı" mesajı görünsün
    if (!nextOpen && eventDetails.reason === "trigger-press") {
      return;
    }
    setOpen(nextOpen);
  };

  const handleCopy = () => {
    const fullUrl = url
      ? `${window.location.origin}${url}`
      : window.location.href;
    navigator.clipboard.writeText(fullUrl);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
      setOpen(false);
    }, COPY_RESET_DELAY);
  };

  return (
    <Tooltip.Provider delay={0}>
      <Tooltip.Root onOpenChange={handleOpenChange} open={open}>
        <Tooltip.Trigger
          render={<Button onClick={handleCopy} size="icon-sm" variant="ghost" />}
        >
          {copied ? (
            <ClipboardCheck className="stroke-brand-blue-500 size-6 stroke-[1.5]" />
          ) : (
            <ShareIcon className="stroke-brand-blue-500 size-6 stroke-[1.5]" />
          )}
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Positioner sideOffset={4}>
            <Tooltip.Popup className="rounded-lg bg-neutral-800 px-2 py-1 text-xs text-white">
              {copied ? "Kopyalandı!" : "Kopyala"}
            </Tooltip.Popup>
          </Tooltip.Positioner>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export { ShareButton };
